import React, { useState } from "react";

import useSelectMedia from "./useSelectMedia";
import { getLinkRef } from "playground/cms/Link/selectors";
import SelectList, {
    SelectListDivider,
    SelectListItem,
    SelectListLabel,
} from "playground/ui/SelectList";
import ConfigSearch from "./../ConfigSearch";
import SitemapSearch from "./../SitemapSearch";
import Popover from "components/Popover";
import IconButton from "components/IconButton";
import MediaLocaleSelect from "./MediaLocaleSelect";
import Icon from "components/Icon";

//import PropTypes from 'prop-types';

export function LinkTypeSelect(props) {
    const { onChange, type, data, onClose } = props;

    const onSelectMedia = useSelectMedia(onChange);

    const linkRef = getLinkRef(type, data) || {};
    const refType = linkRef?.type;
    const action = data?.link_action;
    const isItemPopup = !!data.enable_popup;

    const isMedia = ["media", "media-locale"].includes(refType);
    const targetMediaType = isMedia ? refType : "media";

    let initialView = null;
    if (refType === "sitemap") initialView = "sitemap";
    if (isMedia) initialView = "media";

    const [view, setView] = useState(initialView);

    const handleSetView = (e, v) => {
        e.stopPropagation();
        setView(v);
    };

    const handleSelectSitemap = (id, section = null) => {
        const next = {
            link_ref: {
                type: "sitemap",
                resource_id: id,
                section_id: section,
                url: null,
                link_anchor: null,
            },
        };
        if (section) next.link_ref.custom_anchor = null;
        if (next.enable_popup) next.enable_popup = false;
        onChange(next);
        onClose();
    };

    const handleSelectConfig = (key) => {
        const next = {
            link_ref: {
                type: "config",
                config_key: key,
                resource_id: null,
                url: null,
            },
        };
        if (next.enable_popup) next.enable_popup = false;
        onChange(next);
        onClose();
    };

    const handleItemPopup = () => {
        onChange({ link_ref: null, enable_popup: true });
        onClose();
    };

    if (!view)
        return (
            <SelectList onClick={onClose}>
                <SelectListItem
                    onClick={(e) => handleSetView(e, "sitemap")}
                    isSelected={refType === "sitemap"}
                >
                    Podstrona
                </SelectListItem>
                {type === "cms.items" && action === "modal" && (
                    <SelectListItem
                        onClick={handleItemPopup}
                        isSelected={isItemPopup}
                    >
                        Otwórz element listy
                    </SelectListItem>
                )}
                <SelectListItem
                    onClick={(e) => handleSetView(e, "media")}
                    isSelected={isMedia}
                >
                    Plik z biblioteki
                </SelectListItem>
                <SelectListItem
                    onClick={() => onChange({ link_ref: { type: "external" } })}
                    isSelected={refType === "external"}
                >
                    External
                </SelectListItem>
                <SelectListItem
                    onClick={(e) => handleSetView(e, "config")}
                    isSelected={refType === "config"}
                >
                    Wybierz z ustawień
                </SelectListItem>
                <SelectListItem
                    onClick={() => onChange({ link_ref: null })}
                    isSelected={!refType && !isItemPopup}
                >
                    Wpisz z palca
                </SelectListItem>
            </SelectList>
        );

    if (view === "media") {
        return (
            <>
                <SelectList onClick={onClose}>
                    <SelectListItem
                        icon={<Icon>mui-search</Icon>}
                        onClick={() => onSelectMedia(targetMediaType)}
                    >
                        Wybierz plik
                    </SelectListItem>
                    <SelectListDivider />
                </SelectList>
                <MediaLocaleSelect
                    label={"Wersje językowe"}
                    value={refType}
                    onChange={(type) =>
                        onChange({
                            link_ref: {
                                type,
                                resource_id: linkRef?.resource_id,
                            },
                        })
                    }
                />
                <SelectList>
                    <SelectListItem onClick={(e) => handleSetView(e, null)}>
                        Zmień typ odnośnika
                    </SelectListItem>
                </SelectList>
            </>
        );
    }

    if (view === "config") {
        return (
            <ConfigSearch
                {...props}
                onSelect={handleSelectConfig}
                onClose={(e) => handleSetView(e, null)}
            />
        );
    }

    return (
        <SitemapSearch
            {...props}
            onSelect={handleSelectSitemap}
            onClose={(e) => handleSetView(e, null)}
            pageId={linkRef.resource_id}
            sectionId={linkRef.section_id}
        />
    );
}

LinkTypeSelect.propTypes = {};
LinkTypeSelect.defaultProps = {};

export default LinkTypeSelect;

export function LinkTypeSelectPopover(props) {
    return (
        <Popover
            trigger={({ onClick }) => (
                <IconButton icon={"mui-search"} onClick={onClick} />
            )}
            content={({ onClose }) => (
                <LinkTypeSelect onClose={onClose} {...props} />
            )}
        />
    );
}
